import PropTypes from 'prop-types';
import * as React from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var propTypes = {
  /**
  * A localized string which will be used for shown beside the spinner as well as for accessibility to read aloud by screen-readers
  */
  accessibleText: PropTypes.string.isRequired,

  /**
  * The visual style of the Loader
  */
  size: PropTypes.oneOf(['super', 'standard', 'mini', 'tiny']),

  /**
  * The alignment of text beside the spinner
  */
  layout: PropTypes.oneOf(['vertical', 'horizontal']),

  /**
  * Hide or show the accessibleText
  */
  showText: PropTypes.bool,

  /**
  * Using this will create a box behind the spinner
  */
  overlay: PropTypes.bool
};
var propKeysToRemove = Object.keys(propTypes);
var Spinner = renderWithRef('Spinner', propTypes, function (props, ref) {
  useComponentStylesLoaded('Spinner', SWAN_STYLE_KEY_MAP.spinner);
  var _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      accessibleText = props.accessibleText,
      _props$layout = props.layout,
      layout = _props$layout === void 0 ? 'vertical' : _props$layout,
      _props$showText = props.showText,
      showText = _props$showText === void 0 ? false : _props$showText,
      _props$overlay = props.overlay,
      overlay = _props$overlay === void 0 ? false : _props$overlay;
  var classNames = new Set([]);
  classNames.add('swan-spinner');
  if (size !== 'standard') classNames.add("swan-spinner-".concat(size));
  if (layout === 'horizontal') classNames.add("swan-spinner-horizontal");
  if (showText) classNames.add("swan-spinner-show-text");
  if (overlay) classNames.add("swan-spinner-overlay");
  return /*#__PURE__*/React.createElement(RenderComp, {
    root: "span",
    forwardedRef: ref,
    propKeysToRemove: propKeysToRemove,
    classNames: classNames,
    props: _object_spread({}, props)
  }, /*#__PURE__*/React.createElement("span", {
    className: "swan-spinner-animation"
  }, /*#__PURE__*/React.createElement("span", {
    className: "swan-spinner-animation-inner"
  })), /*#__PURE__*/React.createElement("span", {
    className: "swan-spinner-text"
  }, accessibleText));
});
Spinner.defaultProps = {
  size: 'standard',
  layout: 'vertical',
  showText: false,
  overlay: false
};
export { Spinner };